/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { createEnum } from 'fierry/util/enum';


export default createEnum('Pending', 'Active', 'SignedOut');
